// extracted by mini-css-extract-plugin
export var details = "CruiseItineraryFlightPackage-module--details--5759a";
export var expand = "CruiseItineraryFlightPackage-module--expand--b2fef";
export var faresBadge = "CruiseItineraryFlightPackage-module--fares-badge--67d19";
export var header = "CruiseItineraryFlightPackage-module--header--55fb0";
export var icon = "CruiseItineraryFlightPackage-module--icon--ad501";
export var inclusionItem = "CruiseItineraryFlightPackage-module--inclusionItem--d0f37";
export var inclusions = "CruiseItineraryFlightPackage-module--inclusions--444ea";
export var item = "CruiseItineraryFlightPackage-module--item--e9c2e";